/**
 * Performs a form POST to the specified URL with the given data.
 * This is used for redirecting to Azure authentication.
 *
 * @param {string} url - The URL to post to
 * @param {object} data - The form data to include in the post
 */
export function postRedirect(url, data) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';

    Object.keys(data).forEach(key => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = data[key];
        form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
}
